export var DefaultEmailStyles = {
    a: {
        color: '#109FFF',
        textDecoration: 'none',
    },
};
//# sourceMappingURL=default-email-styles.js.map